import { Stack } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";
import { QuestionsContainer } from "../../Components/ProofReadingComponents/QuestionsContainer";
export const ProofReading: FC = () => {
  return (
    <Stack
      width={"calc(100% - 16px)"}
      height={"calc(100% - 4px)"}
      margin="0 8px 4px"
      sx={{
        "& img": { maxWidth: "100%" },
      }}
    >
      <Stack direction={"row"} width={"100%"} height={"100%"}>
        <Stack
          minWidth={"350px"}
          maxWidth={"350px"}
          height={"100%"}
          boxShadow="rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px"
          bgcolor="white"
        >
          <QuestionsContainer />
        </Stack>
        <Stack
          width={"calc(100% - 350px)"}
          sx={{
            display: "flex",
            flexDirection: "row",
          }}
          height={"100%"}
        >
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  );
};
